<div class="select-assets">
  <assets [type]="data?.type" [title]="data?.title" [showAll]="type === 'all'" [isModal]="true" (selectForModal)="loadAssets($event)"
          [content]="content" [parentTitle]="data?.parent" (changeTabModal)="changeTab($event)" [multiple]="multiple" [dynamicContent]="data.dynamicContent"></assets>
  <div class="button-container">
    <button (click)="insertAssets()" [disabled]="!selectedAssets?.length" class="ibexfusion-raised-button small"
            [class.mat-button-disabled]="!selectedAssets?.length" mat-button>{{ 'general.insert' | translate }}
    </button>
  </div>
</div>

